export default "__VITE_ASSET__DK88PAPF__"